'use client';

import React, { useEffect, useMemo } from 'react';
import { useSession } from 'next-auth/react';
import { AuthContextType } from '@/types/Auth';
import { AuthContext } from '@/contexts/Auths';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: Readonly<AuthProviderProps>) => {
  const { data: session } = useSession();
  useEffect(() => {
    if (session?.user?.accessToken) {
      localStorage.setItem('token', session?.user?.accessToken);
    }
  }, [session?.user?.accessToken]);

  const contextValue: AuthContextType = useMemo(
    () => ({
      organization: session?.user?.organization,
      session,
    }),
    [session],
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
